import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import "./PersonalSchedule.scss"
import PostService from '../../../API/PostService';
import { useFetching } from '../../../hooks/useFetching';
import PersonalScheduleItem from '../PersonalScheduleItem/PersonalScheduleItem';
import { getDaysOfMonth } from '../../../helpers/datetime';
import { setSalonsAction } from '../../../store/scheduleReducer';

const PersonalSchedule = ({ slots = [], date = null, confirmed = false, pending = true, headerHeight = null, nextMonth = false }) => {
    const dispatch = useDispatch();
    const salons = useSelector(state => state.schedule.salons);
    const personalData = useSelector(state => state.personal.personalData);

    const [monthDays, setMonthDays] = useState([]);

    const todayRef = useRef(null);

    useEffect(() => {
        setMonthDays(getDaysOfMonth(nextMonth));
        fetchSalons();
    }, []);

    useEffect(() => {
        if (todayRef.current) {
            const element = todayRef.current;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 180;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
        
    }, [pending]);

    const getSlotByDate = (date) => {
        const slot = slots.find((slot) => slot.date_format == date);
        return slot ? slot : 'weekend';
    };

    const [fetchSalons] = useFetching(async () => {
        const response = await PostService.getWorkerSites()
        if (response.data.success && response.data.result !== false) {
            dispatch(setSalonsAction(response.data.result))
        }
    });

    return (
        <div className="personal__schedule-body">
            <div className="personal__schedule-top" style={{top: headerHeight ? headerHeight : '121px'}}>
                <div className="personal__schedule-subtitle">
                    График работы на <span>{date}</span>
                </div>
            </div>

            {confirmed ?
                <div className="personal__schedule-list">
                    {monthDays.map((day) => {
                        const date = day.date_format;
                        const slot = getSlotByDate(date);

                        const salon = salons.find((salon) => salon.id == slot.site_id);

                        const is_today = day.is_today;

                        return (
                            <PersonalScheduleItem
                                key={day.date_format}
                                elem={day}
                                slot={slot}
                                salon={salon}
                                nextMonth={nextMonth}
                                ref={is_today ? todayRef : null}
                            />
                        );
                    })}
                </div> :
                <>
                    {!confirmed && pending ?
                        <div className="personal__schedule-not-found">
                            <span>Загрузка...</span>
                        </div> :
                        <div className="personal__schedule-not-found">
                            <span>Ваш график еще не утверждён</span>
                        </div>
                    }
                </>
            }
        </div>
    );
};

export default PersonalSchedule;
